import { Component, OnInit, inject } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { SelectionSetId } from 'src/app/enums/selection-set-id.enum';

@Component({
    selector: 'app-replenishment',
    templateUrl: './replenishment.component.html',
    styleUrls: ['./replenishment.component.scss'],
    standalone: false
})
export class ReplenishmentComponent implements OnInit {

	protected filtersSelectionSetId: SelectionSetId = SelectionSetId.ReplenishmentOverviewFilters;

	private _titleService: Title = inject(Title);

	ngOnInit(): void {
		this._titleService.setTitle("MRP - Overview");
	}
}
